// A20 — reklama, QO'SHIMCHA ekranlar (banned-categories/stats/channel-revenue/
// complaints/policy). Lane C `adsApi.ts` (uncommitted) ga TEGMASLIK uchun alohida
// fayl. Barcha endpoint REAL + deployed (backend live). HOT fayllarга tegmaydi.
import { api } from '@/lib/api'

export interface BannedCategory {
  id: number
  category: string
  note: string | null
  created_at: string
}
export interface ChannelRevenue {
  channel_ref: string
  impressions: number
  revenue: number
  updated_at: string
}
export interface Complaint {
  id: number
  campaign_id: number
  creative_id: number
  reporter: string
  reason: string
  status: string
  created_at: string
}
export interface AdStats {
  advertisers: number
  active_campaigns: number
  total_spend: number
  impressions: number
  clicks: number
  ctr: number
  top_campaigns?: { title: string; spent: number }[]
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchBannedCategories = (s?: AbortSignal) =>
  api.get<{ categories: BannedCategory[] }>('/admin/ads/banned-categories', opt(s)).then((d) => d.categories ?? [])
export const addBannedCategory = (category: string, note = '') =>
  api.post<{ id: number }>('/admin/ads/banned-categories', { category, note })
export const deleteBannedCategory = (id: number) => api.del(`/admin/ads/banned-categories/${id}`)

export const fetchChannelRevenue = (s?: AbortSignal) =>
  api.get<{ channels: ChannelRevenue[] }>('/admin/ads/channel-revenue', opt(s)).then((d) => d.channels ?? [])

export const fetchComplaints = (status = '', s?: AbortSignal) =>
  api
    .get<{ complaints: Complaint[] }>('/admin/ads/complaints', {
      query: status ? { status } : {},
      ...(s ? { signal: s } : {}),
    })
    .then((d) => d.complaints ?? [])
export const resolveComplaint = (id: number, action: 'resolve' | 'dismiss') =>
  api.post(`/admin/ads/complaints/${id}/${action}`, {})

export const fetchAdStats = (s?: AbortSignal) =>
  api.get<{ stats: AdStats }>('/admin/ads/stats', opt(s)).then((d) => d.stats)

export const fetchPolicy = (s?: AbortSignal) =>
  api.get<{ content: string }>('/admin/ads/policy', opt(s)).then((d) => d.content ?? '')
export const savePolicy = (content: string) => api.put('/admin/ads/policy', { content })

export const ADSX_STR = {
  banned: 'Запрещённые категории',
  bannedDesc: 'Категории рекламы, запрещённые к показу',
  stats: 'Статистика рекламы',
  channelRev: 'Доход каналов',
  complaints: 'Жалобы на рекламу',
  policy: 'Рекламная политика',
  policyDesc: 'Текст политики — показывается рекламодателям',
  category: 'Категория',
  note: 'Примечание',
  created: 'Создан',
  add: 'Добавить',
  delete: 'Удалить',
  categoryPrompt: 'Название запрещённой категории:',
  channel: 'Канал',
  impressions: 'Показы',
  revenue: 'Доход',
  updated: 'Обновлён',
  reporter: 'Заявитель',
  reason: 'Причина',
  status: 'Статус',
  resolve: 'Решить',
  dismiss: 'Отклонить',
  save: 'Сохранить',
  saved: 'Сохранено',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет данных',
  refresh: 'Обновить',
  advertisers: 'Рекламодателей',
  activeCampaigns: 'Активных кампаний',
  totalSpend: 'Общий расход',
  clicks: 'Клики',
  ctr: 'CTR',
  topCampaigns: 'Топ кампаний',
} as const
